const postCloneEquipmentModels = {
  toastr: 'Cloned Model Equipment',
  toastr1: ' has been successfully added',
  toastrError: 'Name already registered',
  toastrError1: 'Enter another name'
};

export default postCloneEquipmentModels;
